$(document).ready(function() {
console.log("reactiveUV init slider");
var TotalSlideNum = 6;    
$('#gallery').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: false,
    autoplaySpeed: 0,
    speed: 500,
    pauseOnHover: false,
   infinite:true,
   responsive: [
    {
      // tablet
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
          slidesToScroll: 3
      }
    },
    {
      // mobile portrait
      breakpoint: 759,
      settings: {
        slidesToShow: 1.2,
          slidesToScroll: 1,
        infinite: false
      }
    }]
  });


var prev = document.getElementsByClassName('slick-prev');
var next = document.getElementsByClassName('slick-next');
console.log("prev", prev);
  console.log("next", next);
  if(prev.length > 0){
    document.getElementsByClassName('slick-prev')[0].innerHTML = "<button aria-label=\"button\" class=\"slick-prev button button--style2 button--circle lh1 slick-arrow\"><span></span></button>";
  }

  if(next.length > 0){
      document.getElementsByClassName('slick-next')[0].innerHTML = "<button aria-label=\"button\" class=\"slick-next button button--style2 button--circle lh1 slick-arrow\" style=\"border\"><span></span></button>";
  }
  
    


})

